/**
 * @example
 *  - ['allowance']
 *  - ['allowance', 'list', <filters>]
 *  - ['allowance', 'detail', <id>]
 */
const AllowanceQueryKeys = {
  all: () => ['allowance'] as const,
  list: (filters?: Record<string, unknown>) =>
    [
      ...AllowanceQueryKeys.all(),
      'list',
      ...(filters ? [filters] : [])
    ] as const,
  detail: (id?: number) =>
    [
      ...AllowanceQueryKeys.all(),
      'detail',
      ...(id !== undefined ? [id] : [])
    ] as const
};

export default AllowanceQueryKeys;
